import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
export default function AdminProfessores(props) {
  let teachers = props.teachers;
  let setTeachers = props.setTeachers;
  let students = props.students;
  let setStudents = props.setStudents;
  let showFlash = props.showFlash;
  let editingTeacher = props.editingTeacher;
  let setEditingTeacher = props.setEditingTeacher;
  const [form, setForm] = useState({
    nome: "",
    ativo: true,
  });
  useEffect(() => {
    if (editingTeacher) {
      const teacher = teachers.find(
        (teacherId) => teacherId.id === editingTeacher,
      );
      if (teacher) {
        setForm({
          ...teacher,
        });
      }
    } else
      setForm({
        nome: "",
        ativo: true,
      });
  }, [editingTeacher, teachers]);
  return (
    <div className={"ga"}>
      <div
        style={{
          overflowX: "auto",
        }}
      >
        <table className={"tbl"}>
          <thead>
            <tr>
              <th>{"Nome"}</th>
              <th>{"Alunos"}</th>
              <th>{"Status"}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {teachers.map((teacher) => (
              <tr key={teacher.id}>
                <td>
                  <strong>{teacher.nome}</strong>
                </td>
                <td>
                  {
                    students.filter(
                      (student) => student.professor_id === teacher.id,
                    ).length
                  }
                </td>
                <td>
                  <span
                    className={"bst ".concat(teacher.ativo ? "bon" : "bof")}
                  >
                    {teacher.ativo ? "Ativo" : "Inativo"}
                  </span>
                </td>
                <td
                  style={{
                    textAlign: "right",
                    whiteSpace: "nowrap",
                  }}
                >
                  <button
                    className={"btn bg bs"}
                    style={{
                      marginRight: 4,
                    }}
                    onClick={() => setEditingTeacher(teacher.id)}
                  >
                    {"Editar"}
                  </button>
                  <button
                    className={"btn bd bs"}
                    onClick={() =>
                      ((item) => {
                        (async () => {
                          try {
                            await api.delete("/teachers?id=".concat(item.id));
                            setTeachers(
                              teachers.filter(
                                (teacherId) => teacherId.id !== item.id,
                              ),
                            );
                            setStudents(
                              students.map((student) =>
                                student.professor_id === item.id
                                  ? {
                                      ...student,
                                      professor_id: null,
                                    }
                                  : student,
                              ),
                            );
                            if (editingTeacher === item.id) {
                              setEditingTeacher(null);
                            }
                            showFlash("Excluido.");
                          } catch (err) {
                            showFlash(
                              err.response?.data?.message ||
                                "Nao foi possivel excluir o professor.",
                              "er",
                            );
                          }
                        })();
                      })(teacher)
                    }
                  >
                    {"X"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (!form.nome.trim()) {
            showFlash("Nome obrigatório.", "er");
            return;
          }
          const dados = {
            ...form,
            nome: form.nome.trim(),
          };
          try {
            const responseData2 = editingTeacher
              ? await api.put("/teachers?id=".concat(editingTeacher), dados)
              : await api.post("/teachers", dados);
            const saved = responseData2.data?.data ?? responseData2.data;
            if (editingTeacher) {
              setTeachers(
                teachers.map((teacher) =>
                  teacher.id === editingTeacher ? saved : teacher,
                ),
              );
              showFlash("Atualizado.");
            } else {
              setTeachers([...teachers, saved]);
              showFlash("Cadastrado.");
            }
            setEditingTeacher(null);
          } catch (err) {
            showFlash(
              err.response?.data?.message ||
                "Nao foi possivel salvar o professor.",
              "er",
            );
          }
        }}
        className={"fc"}
      >
        <div
          style={{
            fontWeight: 700,
            color: "#1F4754",
            fontSize: 13,
            marginBottom: 10,
          }}
        >
          {editingTeacher ? "Editar" : "Novo"}
          {" Professor"}
        </div>
        <div className={"fg"}>
          <label>{"Nome"}</label>
          <input
            className={"inp"}
            value={form.nome}
            onChange={(event) =>
              setForm({
                ...form,
                nome: event.target.value,
              })
            }
            required={true}
          />
        </div>
        <div className={"fg"}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              textTransform: "none",
              letterSpacing: "normal",
              fontSize: 13,
              color: "#1F4754",
            }}
          >
            <input
              type={"checkbox"}
              checked={form.ativo}
              onChange={(event) =>
                setForm({
                  ...form,
                  ativo: event.target.checked,
                })
              }
            />{" "}
            {"Ativo"}
          </label>
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
          }}
        >
          <button type={"submit"} className={"btn"}>
            {editingTeacher ? "Atualizar" : "Cadastrar"}
          </button>
          {editingTeacher && (
            <button
              type={"button"}
              className={"btn bg"}
              onClick={() => setEditingTeacher(null)}
            >
              {"Cancelar"}
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
export { AdminProfessores };
